import { config } from "../../../config/config";

const ENV_CONFIG = {
  development: {
    label: "Ambiente de desarrollo",
    banner: "bg-amber-400 text-amber-950 border-amber-600/50",
    dot: "bg-amber-900",
  },
  staging: {
    label: "Ambiente de prueba",
    banner: "bg-orange-600 text-orange-50 border-orange-400/50",
    dot: "bg-orange-200",
  },
} as const;

export const EnvIndicator = () => {
  if (!config.showEnvIndicator) return null;

  const env = config.APP_ENV as "development" | "staging";
  const { label, banner, dot } = ENV_CONFIG[env] ?? ENV_CONFIG.staging;

  return (
    <div
      role="status"
      className={`fixed inset-x-0 top-0 z-9999 flex h-(--height-env-banner) items-center justify-center gap-2 border-b px-3 text-xs font-bold uppercase tracking-widest shadow-sm select-none ${banner}`}
    >
      <span
        className={`h-1.5 w-1.5 shrink-0 rounded-full ${dot} animate-pulse`}
      />
      {label}
    </div>
  );
};
